import React from 'react';
import { GroupPersonality } from 'Types/GroupsTypes';
import DoubleColorHoloSvg from './CompanyProgressSvgs/DoubleColorHoloSvg';
import FourColorHoloSvg from './CompanyProgressSvgs/FourColorHoloSvg';
import SingleColorHoloSvg from './CompanyProgressSvgs/SingleColorHoloSvg';
import ThreeColorHoloSvg from './CompanyProgressSvgs/ThreeColorHoloSvg';

type Props = {
  height?: string,
  width?: string,
  companyHoloColors?: GroupPersonality[],
} & typeof defaultProps;

const defaultProps = {
  height: '570px',
  width: '551px',
  companyHoloColors: [
    {
      color: '#8d8585',
      end: '',
      percentage: 0,
      start: '100%',
    },
  ],
};

const CompanyHoloSvg = function CompanyHoloSvg(props: Props) {
  const { height, width, companyHoloColors } = props;
  return (
    <>
      {companyHoloColors.length === 0 || companyHoloColors.length === 1
        ? (
          <SingleColorHoloSvg
            height={height}
            width={width}
            companyHoloColors={companyHoloColors}
          />
        ) : null}
      {companyHoloColors.length === 2
        ? (
          <DoubleColorHoloSvg
            height={height}
            width={width}
            companyHoloColors={companyHoloColors}
          />
        ) : null}
      {companyHoloColors.length === 3
        ? (
          <ThreeColorHoloSvg
            height={height}
            width={width}
            companyHoloColors={companyHoloColors}
          />
        ) : null}
      {companyHoloColors.length === 4
        ? (
          <FourColorHoloSvg
            height={height}
            width={width}
            companyHoloColors={companyHoloColors}
          />
        ) : null}
    </>
  );
};

CompanyHoloSvg.defaultProps = defaultProps;
export default CompanyHoloSvg;
